import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import styles from './HeaderButton.module.css';

type HeaderButtonProps = {
  theme: 'light' | 'dark';
  children: React.ReactNode;
  to?: string;
  isHeaderHovered: boolean;
  onClick?: () => void;
};

const HeaderButton: React.FC<HeaderButtonProps> = ({
  theme,
  children,
  to,
  isHeaderHovered,
  onClick,
}) => {
  return to ? (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn('text_body_b3', styles.button, {
          [styles.light]: theme === 'light',
          [styles.dark]: theme === 'dark',
          [styles.active]: isActive,
          [styles.header_hovered]: isHeaderHovered,
        })
      }
    >
      {children}
    </NavLink>
  ) : (
    <button
      onClick={onClick}
      className={cn('text_body_b3', styles.button, {
        [styles.light]: theme === 'light',
        [styles.dark]: theme === 'dark',
        [styles.header_hovered]: isHeaderHovered,
      })}
    >
      {children}
    </button>
  );
};

export default HeaderButton;
